import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import 'moment-duration-format'
import plural from 'smart-plurals'
import classNames from 'classnames'
import { compose, onlyUpdateForKeys } from 'recompose'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import { IntlProvider } from 'react-intl-redux'

import numeral from 'numeral'
import Link from './Link'

import {sendClickCard} from './../helpers/tagManager'
import { setFromList } from '../store/reducers/lots/single.js'

class ExpirationDateComponent extends React.Component {
  render () {
    const intl = this.props.intl
    const date = this.props.date
    const currentLocale = intl.locale
    return (<span>{getDiff(date, currentLocale, intl)}</span>)
  }
}
const ExpirationDate = injectIntl(ExpirationDateComponent)

const getDiff = (date, currentLocale, intl) => {
  const pluralize = plural.Plurals.getRule(currentLocale)
  const timeTo = moment(date).diff(moment())
  let diff = moment.duration(timeTo).format('d H').split(' ').map(Math.abs)
  let size = diff.length
  diff = diff.map((el, i) => {
    if ((i === 0 && size === 1) || i === 1) {
      return `
        ${el} ${pluralize(el,
  currentLocale === 'ru' ? [
    intl.formatMessage({id: 'common.hour'}),
    intl.formatMessage({id: 'common.hours_few'}),
    intl.formatMessage({id: 'common.hours_many'})
  ] : [
    intl.formatMessage({id: 'common.hour'}),
    intl.formatMessage({id: 'common.hours_few'})
  ]
)}
      `
    } else {
      return `
        ${el} ${pluralize(el,
  currentLocale === 'ru' ? [
    intl.formatMessage({id: 'common.day'}),
    intl.formatMessage({id: 'common.days_few'}),
    intl.formatMessage({id: 'common.days_many'})
  ] : [
    intl.formatMessage({id: 'common.day'}),
    intl.formatMessage({id: 'common.days_few'})
  ]
)}
      `
    }
  })
  return diff.join(' ')
}

const Person = ({ data = {}, isComplete, isDown, isUp, isSpecial, isSingle, handleLoad, type = 'lot', linkPrefix = 'lots', alias = data._id, 
onClick = null, noTime = false, currentLocale, typelot, listName, position, onSelect }) => {
//если у объекта есть price значит это лот с фиксированной ценой, префиск  ссылки делает fixedricelots
if(data.price)
{
  linkPrefix = 'fixedpricelots'
  typelot = 'fixedpricelots'
}
//при наличие alias будет включен в ссылку на лот, если нет остается id
if(data.alias)
{
  alias = data.alias
}

  const clasess = classNames({
    'Lot': true,
    'Lot_single': isSingle,
    'Lot_special': isSpecial,
    'Lot_complete': isComplete
  })
  const isMember = type === 'member'
  const isParticipating = !!data.statsDifference
  const participatinStatus = isParticipating && data.statsDifference.currentUser

  function onClickPerson() {
    if (data && listName && position) {
      sendClickCard(data, listName, position)
      onSelect(listName)
    } else onSelect(null)
    if (onClick) onClick()
  }

  if (data.title && typeof data.title === 'string') data.title = data.title.split(' ').map((el, i) => <span key={i}> {el} </span>)
  return (
    <IntlProvider>
      <Link className={clasess} to={`/${linkPrefix}/${alias}`} onClick={onClickPerson} >
        <div className='Lot__inner'>
          <img className='Lot__img' src={data.miniImage ? data.miniImage : data.image} alt={data.name} onLoad={handleLoad} loading="lazy" />

          {
            isComplete ? <button type='button' className='Lot__button'>
              <FormattedHTMLMessage id='person.tell_us' />
            </button>
              : (isMember || noTime)
                ? null
                : (
                  <span>
                    {(data.closeDate && !isParticipating) && <span className='Lot__time Small'>
                      <FormattedMessage id='person.expiration' />
                      <br /><ExpirationDate date={data.closeDate} />
                    </span>}
                    {(isParticipating && !participatinStatus) && <span className='Lot__meta Small'>
                      <FormattedMessage id='person.overbid' />
                    </span>}
                    {(isParticipating && participatinStatus) && <span className='Lot__meta Small'>
                      <FormattedMessage id='person.leading_bid' />
                    </span>}
                  </span>
                )
          }

          {data.title && <span className={[ 'Lot__name SubHead', 'textSize30', isMember ? 'Lot__name_bottom' : '' ].join(' ')}>{data.title}</span>}
          {
          //Проверка фикс лот или аукцион
          (typelot !== 'fixedpricelots' )
        ? ((!isMember && !isComplete && !noTime) && (<span className='Lot__price Small'>{data.sum || <FormattedMessage id='person.place_bid' />}</span>))
          //Фиксированный лот: цена, кол-во оставшихся, если осталось меньше, чем куплено, то выводит 0
          :( 
            (data.notForSale === false) && (<span className='Lot__price Small'>{(numeral(data.price).format('0,0'))} {data.currency.symbol} <FormattedMessage id='fixedlot.left' /> {(data.count>data.payCount) ? (data.count - data.payCount) : (0)}</span>)
          )
		  }							   
          <div className='Lot__gradient' />
        </div>
      </Link>
    </IntlProvider>
  )
}

const mapDispatch = (dispatch, props) => ({
  onSelect: (listName) => {
    dispatch(setFromList(listName))
  },
})

export default injectIntl(compose(
  connect(null, mapDispatch),
  onlyUpdateForKeys([ 'data' ]),
  connect(
    state => ({currentLocale: state.intl.locale})
  )
)(Person))



// WEBPACK FOOTER //
// ./src/components/Person.jsx